import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { getBrandLoginRedirect } from '@utils/get-brand-redirect.ts';

import { getUrlToBackendApi, request } from '@services/api';

import { GET_ME_QUERY_KEY } from '@hooks/api/user/use-query-me';

const REQUEST_URL = '/profile';

const MUTATION_KEY = ['auth', 'local-login'];

type LoginResponse = {
	meta: {
		access_token: string;
		refresh_token: string;
	};
};

export const useMutationPassOnboarding = (shouldReload?: boolean) => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationKey: MUTATION_KEY,
		mutationFn: async () => {
			return await request<LoginResponse>({
				method: 'put',
				url: getUrlToBackendApi(REQUEST_URL).href,
				data: {
					onboarding_passed: true
				}
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: GET_ME_QUERY_KEY });

			shouldReload && navigate(getBrandLoginRedirect(), { replace: true });
		},
		onError: error => {
			console.error('Error during login mutation:', error);
		}
	});
};
